import { render, staticRenderFns } from "./KIcon.vue?vue&type=template&id=69b456a0&"
import script from "./KIcon.vue?vue&type=script&lang=js&"
export * from "./KIcon.vue?vue&type=script&lang=js&"
import style0 from "./KIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports